<template>
    <div>
        <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
            <div class="row breadcrumbs-top">
                <div class="col-12">
                    <h2 class="content-header-title float-left mb-0">{{ title }} Payment Graph</h2>
                    <div class="breadcrumb-wrapper col-12">
                        
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item">
                                    Statistic
                                </li>
                                <li class="breadcrumb-item active">
                                    Payment
                                </li>
                            </ol> 
                    </div>
                </div>
            </div>
        </div>

        <div class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none">   
            <div class="form-group breadcrum-right">
                <button class="btn btn-primary btn-sm pull-right ml-1"  @click="$router.push(`/payments?type=${type}`)"><i class="feather icon-list"></i> List View</button>
            </div>
        </div>
    </div>

    <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <transition name="fade">
                        <div class="card border-bottom">
                            <div class="card-header">
                                <h4 class="card-title">
                                    {{trans('general.filter')}}
                                </h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="">Cohort</label>
                                            <select class="form-control" name="cohort_id" v-model="cohort_id" @change="onCohortChange($event)">
                                                <option value="all">All Cohorts</option>
                                                <option v-for="cohort in cohorts" :value="cohort.id">{{cohort.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="">Cycle</label>
                                            <select class="form-control" name="cycle_id" v-model="cycle_id" @change="onCycleChange($event)">
                                                <option value="all">All Cycles</option>
                                                <option v-for="cycle in cycles" :value="cycle.id">{{cycle.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="">Trench</label>
                                            <select class="form-control" name="trench_id" v-model="trench_id" @change="onTrenchChange($event)">
                                                <option value="all">All Trenchs</option>
                                                <option v-for="trench in trenches" :value="trench.id">{{trench.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
          <div class="row">
              <div class="col-lg-12 col-md-6 col-12">
                  <div class="card">
                      <div class="card-header d-flex justify-content-between align-items-end">
                          <h4 class="card-title" v-if="type == 'paid'">Paid Beneficiaries</h4>
                          <h4 class="card-title" v-if="type == 'not_paid'">Not Paid Beneficiaries</h4>

                          <p class="font-medium-5 mb-0"><i class="feather icon-settings text-muted cursor-pointer"></i></p>
                      </div>
                      <div class="card-content">
                          <div class="card-body pb-0">
                              <beneficiaryChart :data="getChartData" :label="getChartLabel" />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          
        </section>
   
   </div>
    </div>
</template>

<script>
import beneficiaryChart from '../../components/beneficiary-chart'
    export default {
        components: { beneficiaryChart },
        data() {
            return {
                type: this.$route.query.type,
                cohort_id: this.$route.query.cohort,
                cycle_id: this.$route.query.cycle,
                trench_id: this.$route.query.trench,
                title: '',
                cohorts: [],
                cycles: [],
                trenches: [],
                chartData: [],
                chartLabel: []
            }
        },
        mounted(){
            this.fetchPreRequisites();
            axios.get('/api/statistic/payments/?type= ' + this.$route.query.type + '&cohort=' + this.$route.query.cohort + '&cycle=' + this.$route.query.cycle + '&trench=' + this.$route.query.trench)
                .then(response => response.data)
                .then(response => {
                    this.title = response.title[0];
                    this.chartLabel = response.labels;
                    this.chartData = response.data;
                    if (response.data <= 0) {
                        toastr.error('No record found for the selected entry');
                    }
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                })

                console.log(this.$route.query.cohort)

        },
        computed: {
          getChartData() {
            return this.chartData
          },
          getChartLabel() {
            return this.chartLabel
          }
        },
        methods: {
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.cohorts = response.cohorts;
                        this.cycles = response.cycles;
                        this.trenches = response.trenches;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            onCohortChange(event) {
                this.cohort_id = event.target.value;
            },
            onCycleChange(event) {
                this.cycle_id = event.target.value;
            },
            onTrenchChange(event) {
                this.trench_id = event.target.value;
                window.location.href = '/statistic/payments/?type=' + this.type + '&cohort=' + this.cohort_id + '&cycle=' + this.cycle_id + '&trench=' + this.trench_id;
            }
        }
       
    }
</script>
<style>
    .shw-rside{
        width: 500px;
    }
</style>